import { render, staticRenderFns } from "./esPrivacy.vue?vue&type=template&id=4c6df1bb&scoped=true&"
import script from "./esPrivacy.vue?vue&type=script&lang=js&"
export * from "./esPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./esPrivacy.vue?vue&type=style&index=0&id=4c6df1bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6df1bb",
  null
  
)

export default component.exports